// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterAd: React.FC<{ width?: number; height?: number }> = ({ width = 24, height = 24 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m11.994 8.245.625.937-5.732 8.598-.834 1.251h8.754l.834-1.25 1.667-2.502.626-.937.625.937-.625.938-1.043 1.563-.833 1.251H24V24H0v-4.969h4.803l.833-1.25zM24 0v17.78h-1.897l-2.606-3.908-.626-.938-1.875-2.813-.625.938-.313.468-.625.939-3.544 5.314h-1.25l4.168-6.253.626-.937-1.876-2.814-.625-.938-1.877-2.814-.627.935L1.88 17.78H0V0z"
            />
        </svg>
    );
};

export default React.memo(FooterAd);
